module.exports = __webpack_public_path__ + "static/media/Image-Open.43e4c0b7.svg";